import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgChartsModule } from 'ng2-charts';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxCurrencyModule } from 'ngx-currency';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { SharedModule } from 'src/app/shared/shared.module';
import { DocumentoObrasEditComponent } from './components/documento-obras-edit/documento-obras-edit.component';
import { DocumentoObrasListComponent } from './components/documento-obras-list/documento-obras-list.component';
import { HistoricoAtualizacoesListComponent } from './components/historico-atualizacoes-list/historico-atualizacoes-list.component';
import { ObrasAdminExportarComponent } from './components/obras-admin-exportar/obras-admin-exportar.component';
import { ObrasAdminGeralComponent } from './components/obras-admin-geral/obras-admin-geral.component';
import { ObrasAdminStatusEditComponent } from './components/obras-admin-status-edit/obras-admin-status-edit.component';
import { ObrasAdminStatusListComponent } from './components/obras-admin-status-list/obras-admin-status-list.component';
import { ObrasEditComponent } from './components/obras-edit/obras-edit.component';
import { PesquisaGeralObrasComponent } from './components/pesquisa-geral-obras/pesquisa-geral-obras.component';
import { QrObrasRoutes } from './qr-obras.routing';
import { DocumentoObrasFiltersResolver, DocumentoObrasResolver } from './resolver/documento-obras.resolver';
import { QrObraAdminStatusResolver } from './resolver/obras-admin-status.resolver';
import { QrObraCombosResolver, QrObraFiltersResolver } from './resolver/qr-obras-filters.resolver';
import { QrObraVerifyProjectResolver } from './resolver/qr-obras-verify-project.resolver';
import { QrObraResolver } from './resolver/qr-obras.resolver';
import { DocumentoObrasService } from './services/documento-obras.services';
import { ObrasAdminGeralService } from './services/obras-admin-geral.service';
import { QrObraAdminStatusService } from './services/qr-obra-admin-status-service';
import { QrObrasService } from './services/qr-obra-service';
import { QRCodeModule } from 'angularx-qrcode';
import { QrObrasExportService } from './services/qr-obras-export.service';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CollapseModule.forRoot(),
    QrObrasRoutes,
    NgSelectModule,
    BsDatepickerModule.forRoot(),
    NgxMaskDirective,
    NgxMaskPipe,
    NgChartsModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    NgxCurrencyModule,
    MatButtonModule,
    MatBottomSheetModule,
    MatListModule,
    SharedModule,
    QRCodeModule
  ],
  exports: [
  ],
  declarations: [
    PesquisaGeralObrasComponent,
    ObrasEditComponent,
    DocumentoObrasListComponent,
    DocumentoObrasEditComponent,
    HistoricoAtualizacoesListComponent,
    ObrasAdminGeralComponent,
    ObrasAdminExportarComponent,
    ObrasAdminStatusListComponent,
    ObrasAdminStatusEditComponent,
  ],
  providers: [
    QrObrasService,
    QrObraAdminStatusService,
    QrObraAdminStatusResolver,
    QrObraFiltersResolver,
    QrObraCombosResolver,
    QrObraResolver,
    QrObraVerifyProjectResolver,
    DocumentoObrasService,
    DocumentoObrasResolver,
    DocumentoObrasFiltersResolver,
    ObrasAdminGeralService,
    ObrasAdminGeralService,
    QrObrasExportService,
  ],
})
export class QrObrasModule { }
